import {AirlineTheme} from "../../../../services/theme/interfaces/airline.theme";

export function flightItinerarySpaceBetweenIconAndHeaderText(theme: AirlineTheme): string {
    return theme.spacing.spacing16;
}
